import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { AppInsightsService } from '../shared/services/appinsights/appinsights.service';
import { ConfigService } from '../shared/templates/Locale/locales.service';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-error-maintenance',
  templateUrl: './error-maintenance.component.html'
})
export class ErrorMaintenanceComponent implements OnInit {
  constructor(private appInsightsService: AppInsightsService) { }

  ngOnInit() {
    this.appInsightsService.logPageView('MaintenanceErrorPageComponent');
  }

}
